function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import clsx from 'clsx';
import React from 'react';
import { Dropdown } from '@isyc-react/design/overlays';
import { useTranslation } from 'react-i18next';
import { nsform } from "../../../i18n/namespaces";
import '@isyc-react/design/main';
import "./input-locator.style.scss";
export const LocatorSearchButton = props => {
  const {
    setModal,
    onFocus,
    readOnly,
    disabled,
    urlLocator,
    loadingUrls,
    errorUrls
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    role: "button",
    onClick: () => {
      if (!readOnly && !disabled && urlLocator) {
        setModal(true);
        onFocus && onFocus();
      }
    },
    "aria-label": t('input.locator.button.fullSearch'),
    className: clsx('mdi mdi-magnify', {
      'cursor-pointer text-primary': !readOnly && !disabled && urlLocator
    })
  }));
};
export const LocatorDetailButton = props => {
  const {
    value,
    urlDetail,
    loadingUrls,
    errorUrls
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    role: "button",
    onClick: () => {
      if (value && value.active && urlDetail) window.location.href = `${urlDetail}?id=${value === null || value === void 0 ? void 0 : value.id}&action=load`;
    },
    "aria-label": t('input.locator.button.goDetail'),
    className: clsx('mdi mdi-arrow-top-right', {
      'cursor-pointer text-primary': value && value.active && urlDetail
    })
  }));
};
export const LocatorWindowDetailButton = props => {
  const {
    value,
    urlDetail,
    loadingUrls,
    errorUrls
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    role: "button",
    onClick: () => {
      if (value && value.active && urlDetail) window.open(`${urlDetail}?id=${value === null || value === void 0 ? void 0 : value.id}&action=load`);
    },
    "aria-label": t('input.locator.button.goDetailWindow'),
    className: clsx('mdi mdi-window-restore', {
      'cursor-pointer text-primary': value && value.active && urlDetail
    })
  }));
};
export const LocatorDeleteButton = props => {
  const {
    value,
    onChange,
    readOnly,
    disabled
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    role: "button",
    onClick: () => {
      if (value && !readOnly && !disabled) onChange && onChange(null);
    },
    "aria-label": t('input.locator.button.delete'),
    className: clsx('mdi mdi-delete', {
      'cursor-pointer text-primary': value && !readOnly && !disabled
    })
  }));
};
export const LocatorExtraButton = props => {
  const {
    items,
    children
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  const [show, setShow] = React.useState(false);

  // TODO update dropdown menu with OverlayContainer
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: true,
    show: show,
    onToggle: nextShow => setShow(nextShow)
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative inline-block"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => /*#__PURE__*/React.createElement("i", _extends({}, toggleProps, {
    role: "button",
    "aria-label": t('input.locator.button.extraActions'),
    className: "mdi mdi-dots-vertical cursor-pointer ms-2",
    onClick: () => meta.toggle(!show)
  }))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: true,
    offset: [0, 8]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement("div", _extends({}, menuProps, {
    className: "input-locator-extra-overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "py-2"
  }, items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    onClick: () => meta.toggle && meta.toggle(!meta.show),
    className: "dropdown-item px-6 py-2",
    key: index
  }, children(item)))))))));
};